import React, { useEffect, useRef } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Row, Col, Card, Descriptions, Breadcrumb, Table, Tag } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSession } from 'app/shared/reducers/authentication';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { APP_TIMESTAMP_FORMAT, AUTHORITIES } from 'app/config/constants';
import { getVirement } from './virement.reducer';
import { TextFormat } from 'react-jhipster';

export const ViremeentDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const Loading = useAppSelector(state => state.virement.loading);
  useEffect(() => {
    dispatch(getSession);
    dispatch(getVirement(props.match.params.id));
  }, []);
  const virementList = useAppSelector(state => state.virement.entity);
  const { match } = props;
  const columns = [
    { title: '', dataIndex: 'label' },
    { title: '', dataIndex: 'value' },
  ];
  const data = [
    { key: '1', label: 'Montant', value: <span>{`${virementList.montant} FCFA`}</span> },
    { key: '2', label: 'Wave', value: <span>{`${virementList.waveMontant} FCFA`}</span> },
    { key: '3', label: 'OMoney', value: <span>{`${virementList.omMontant} FCFA`}</span> },
    { key: '4', label: 'Description', value: <span>{`${virementList.description}`}</span> },
    {
      key: '5',
      label: 'Date de la demande',
      value: <TextFormat type="date" value={`${virementList.dateEmission}`} format={APP_TIMESTAMP_FORMAT} />,
    },
    {
      key: '6',
      label: 'Statut',
      value: (
        <span>
          {virementList.statutVirement === 'ENCOURS' ? (
            <Tag color="red">En attente</Tag>
          ) : virementList.statutVirement === 'VALIDE' ? (
            <Tag color="green">Validée</Tag>
          ) : null}
        </span>
      ),
    },
  ];

  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to={`/virements`} hidden={!isAdmin}>
            Virements
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={`${match.url}`}>Détails</Link>
        </Breadcrumb.Item>
      </Breadcrumb>
      <Card>
        <Table sticky columns={columns} dataSource={data} pagination={false} bordered loading={Loading} />
      </Card>
    </>
  );
};
export default ViremeentDetail;
